import React from "react";
import "./Header.css";
import HeaderVideo from "./HeaderVideo/HeaderVideo";
import HeaderShare from "./HeaderShare/HeaderShare";
import layerBlue from "../../assets/header/layers/blue.png";
import layerGreen from "../../assets/header/layers/green.png";
import layerOrange from "../../assets/header/layers/orange.png";
import layerRed from "../../assets/header/layers/red.png";
import goFuther from "../../assets/header/logo/goFurther.png";
import { Grid, Row, Col } from "react-bootstrap";
import { prefix } from "../../scripts/helpers/constants";

const header = props => {
  let image = null;
  switch (props.headerColor) {
    case "blue":
      image = layerBlue;
      break;
    case "green":
      image = layerGreen;
      break;
    case "orange":
      image = layerOrange;
      break;
    case "red":
      image = layerRed;
      break;
    default:
      image = layerBlue;
  }

  return (
    <header
      className={prefix + "-c-header"}
      style={{ backgroundImage: "url(" + image + ")" }}
    >
      <Grid fluid={true} className="sub-header">
        <Row className="no-margin">
          <Col xs={12} className="sub-header-logo-social no-padding">
            <div className="header-logo-social">
              <img src={goFuther} alt={props.images.goFuther} />
              <HeaderShare reference={props.social} />
            </div>
          </Col>
          <h1>{props.headerText}</h1>
          <div className="header-video">
            <HeaderVideo
              videoCode={props.videoContent.videoCode}
              videoFirstTitle={props.videoContent.videoFirstTitle}
              videoSecondTitle={props.videoContent.videoSecondTitle}
            />
          </div>
        </Row>
      </Grid>
    </header>
  );
};

export default header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js